export interface AllFieldsQuery { Type: string; FieldName: string; FieldValue: string; }

/**
 * The search box query. FieldName "*" = every field the class map marks SearchByDefault; that mapping exists
 * only in the Lucene index, so a list on the NHibernate repository searches Title.
 */
export function allFieldsDefaultQuery(repositoryName: string): AllFieldsQuery {
  const nhibernate = (repositoryName || '').toLowerCase() === 'nhibernate';
  return { Type: 'FieldValue', FieldName: nhibernate ? 'Title' : '*', FieldValue: '*' };
}
